import PatientCard from "../../components/PaitientCard/PatientCard";
import PillNav from "../../components/PillNav/PillNav";
import PrescriptionCard from "../../components/PrescriptionCard/PrescriptionCard";
import styles from "./Console.module.scss";
import selectedPatientDataDict from "../appointments/index.js";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import blueCheckIcon from "../../assets/img/success-blue-check-mark.svg";
import { CheckToken } from "../login/AccessToken";

function DoctorConsole(patientData) {
  const { state } = useLocation();
  var stateVal = state;
  // console.log(state.patientData);
  // Here we create a Health Information Request (M3 call) for Prescription Records of the past 2 years.
  console.log("STATE    ", state);
  const history = useHistory();

  var [fetchRequestId, setFetchRequestId] = useState(null);
  var [fetchStatus, setFetchStatus] = useState({});
  var [prescriptionList, setPrescriptionList] = useState([]);
  var [finalStatus, setFinalStatus] = useState(
    "Creating Health Information Consent Request..."
  );
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  if (stateVal == null) {
    // history.push("/doctor/appointments");
    // window.location.reload();
    stateVal = {
      patientData: {
        abha_id: "ayush.agrawal@sbx",
        abha_no: "91-1107-3452-2342",
        age: 21,
        dob: "2001-06-27",
        email: null,
        gender: "Male",
        height: "165 cm",
        name: "Ayush Agrawal",
        patient_id: "PAT_001",
        phone_no: "+917799693043",
        photo: "",
        weight: "65 kg",
      },
    };
  } else {
    console.log("This is State in Prescriptions Page ", stateVal);
  }

  // sample : 1c3cd46a-aea0-46b3-9699-060c0dd9f2b2 | fetchRequestId
  // function checkFetchStatus() {
  //   if (Token()) {
  //     axios
  //       .post(
  //         `${REACT_APP_BACKEND_ROUTE_URL}get_hiu_data_transfer_status/`,
  //         {
  //           request_id: fetchRequestId,
  //         },
  //         {
  //           headers: headers,
  //         }
  //       )
  //       .then((response) => {
  //         console.log("GOT THIS FETCH STATUS");

  //         console.log(response.data);
  //         setFetchStatus(response.data);
  //         fetchStatus = response.data;
  //       })
  //       .catch((error) => {
  //         console.log("FETCH FAILED");
  //         console.log(error);
  //       });
  //   }
  // }

  // function fetchPatientPrescriptions() {
  //   console.log("HERE")
  //   if (Token()) {
  //     axios.post(`${REACT_APP_BACKEND_ROUTE_URL}gateway/create_consent_request_init/`,
  //       {
  //         "consent": {
  //           "purpose": {
  //             "text": "string",
  //             "code": "CAREMGT"
  //           },
  //           "patient": {
  //             "id": stateVal !== undefined && stateVal.length > 0 ?
  //               stateVal.patientData.abha_id ? stateVal.patientData.abha_id : stateVal.patientData.abha_no : ""
  //           },
  //           "hiu": {
  //             "id": "HLTHTEK_HIP_1"
  //           },
  //           "requester": {
  //             "name": "Dr. Saurabh Tripathi",
  //             "identifier": {
  //               "type": "REGNO",
  //               "value": "MH1001",
  //               "system": "https://www.mciindia.org"
  //             }
  //           },
  //           "hiTypes": [
  //             "Prescription"
  //           ],
  //           "permission": {
  //             "accessMode": "VIEW",
  //             "dateRange": {
  //               "from": "2021-01-27T18:30:00.000Z",
  //               "to": "2023-02-01T18:30:00.000Z"
  //             },
  //             "dataEraseAt": "2024-02-01T18:30:00.000Z",
  //             "frequency": {
  //               "unit": "HOUR",
  //               "value": 1,
  //               "repeats": 0
  //             }
  //           }
  //         }
  //       },
  //       {
  //         headers: headers
  //       }
  //     ).then(async (response) => {
  //       console.log("GOT THIS RESPONSE");
  //       console.log(response.data);
  //       setFetchRequestId(response.data.request_id);
  //       fetchRequestId = response.data.request_id;
  //       // console.log("The request id is ",fetchRequestId)

  //       for (var i = 0; i < 15; i++) {
  //         await sleep(5000);
  //         checkFetchStatus();
  //         console.log(fetchStatus)
  //         if (fetchStatus.status == 'Success') {
  //           console.log("CONSENT FOUND")
  //           setFinalStatus("Health Information Consent Created. Awaiting Patient Approval ...")
  //           if (fetchStatus.consent_details.status == 'GRANTED') {
  //             console.log('Patient Granted Data Request')
  //             setFinalStatus("Patient Granted Request. Awaiting Data Push from HIP ...")
  //             if (fetchStatus.data_received_details.length >= 1) {
  //               if (fetchStatus.data_received_details[0].status == 'DATA RECEIVED') {
  //                 console.log('DATA RECEIVED FROM HIP')
  //                 setFinalStatus("Data Received from HIP")
  //                 console.log(fetchStatus.data_received_details[0]);
  //                 var newPrescriptionList = prescriptionList;
  //                 newPrescriptionList[0] = {
  //                   doctor: "Dr. Mehta",
  //                   clinic: "XYZ Clinic",
  //                   date_time: "25/11/2022 06:00 PM",
  //                   decrypted_json: JSON.parse(fetchStatus.data_received_details[0].decrypted_json)
  //                 };
  //                 setPrescriptionList(newPrescriptionList);
  //                 prescriptionList = newPrescriptionList;
  //                 break;
  //               }
  //             }
  //           }
  //         }
  //       }

  //       if (finalStatus != "Data Received from HIP") {
  //         setFinalStatus("Data Fetch Failed. Please Reload the Page to Try again.")
  //       }

  //     }).catch((error) => {
  //       console.log("FETCH FAILED")
  //       console.log(error)
  //     })
  //   }
  // }

  useEffect(() => {
    if (Token()) {
      // fetchPatientPrescriptions();
    }
  }, [authToken]);
  // console.log("THIS IS FINAL STATUS ",finalStatus)
  return (
    <>
      <div class={styles["console-main"]} style={{ margin: "10px" }}>
        <div>
          <PillNav state={state} />
          <PrescriptionCard
            type="Prescription"
            prescriptionList={prescriptionList}
            finalStatus={finalStatus}
            patientData={stateVal ? stateVal.patientData : {}}
          />
        </div>
        <div style={{ margin: "15px" }}>
          <PatientCard patientData={stateVal ? stateVal.patientData : {}} />
        </div>
        <div style={{ marginLeft: "10px" }}>
          <button
            type="border"
            className="button-in-one-line"
            style={{ padding: "10px", border: "1px solid black" }}
          >
            <Link
              to={{
                pathname: `/doctor/Reports`,
                stateVal: { patientData: stateVal.patientData },
              }}
            >
              <b style={{ color: "black" }}>Recent Lab Reports</b>
            </Link>
            <img src="/img/Expand - icon-5.svg" alt="right arrow" />
          </button>
        </div>
      </div>
    </>
  );
}

export default DoctorConsole;
